(() => {
  // Respeta accesibilidad
  const reduceMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;

  function getHeaderRect() {
    const header = document.querySelector(".header") || document.querySelector("header");
    if (!header) return null;
    const r = header.getBoundingClientRect();
    return {
      top: Math.max(0, r.top),
      height: Math.max(140, r.height),
      width: window.innerWidth
    };
  }

  function run() {
    // Canvas overlay
    const canvas = document.createElement("canvas");
    Object.assign(canvas.style, {
      position: "fixed",
      inset: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      zIndex: "9999"
    });
    document.body.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    const dpr = Math.max(1, window.devicePixelRatio || 1);

    function resize() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener("resize", resize, { passive: true });

    // Paleta elegante (marca)
    const colors = ["#FFFFFF", "#FDE047", "#34D399", "#22C55E"];

    const particles = [];
    const gravity = 0.015;   // MUY lento
    const spawnRate = 8;     // elegante, no invasivo
    let last = performance.now();
    let acc = 0;

    const rand = (a, b) => Math.random() * (b - a) + a;

    function spawn(rect) {
      particles.push({
        x: rand(0, rect.width),
        y: rand(rect.top - 30, rect.top + 5),
        vx: rand(-0.12, 0.12),   // casi sin viento
        vy: rand(0.15, 0.45),    // caída suave
        r: rand(4, 7),
        rot: rand(0, Math.PI * 2),
        vr: rand(-0.02, 0.02),
        color: colors[Math.floor(Math.random() * colors.length)]
      });

      if (particles.length > 200) particles.shift();
    }

    function tick(now) {
      const dt = now - last;
      last = now;
      const rect = getHeaderRect();
      if (!rect) return requestAnimationFrame(tick);

      acc += (dt / 1000) * spawnRate;
      while (acc >= 1) {
        spawn(rect);
        acc--;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.forEach(p => {
        p.vy += gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        // Re-ciclar cuando sale del header
        if (p.y > rect.top + rect.height + 20) {
          p.y = rand(rect.top - 40, rect.top);
          p.x = rand(0, rect.width);
        }

        // Dibujar solo en el header
        if (p.y < rect.top - 60 || p.y > rect.top + rect.height + 30) return;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.r / 2, -p.r / 2, p.r, p.r * 0.7);
        ctx.restore();
      });

      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();



